import { useMutation } from '@tanstack/react-query';
import { doc, updateDoc } from 'firebase/firestore';

import { db } from '../config';

interface MarkAsReadParams {
  notificationId: string;
  userId: string;
}

/**
 * Hook to mark an in-app notification as read
 * Sets isRead to true in the user's notification document
 */
export const useMarkNotificationAsRead = () => useMutation({
  mutationFn: async ({ notificationId, userId }: MarkAsReadParams) => {
    const notificationRef = doc(db, 'users', userId, 'notifications', notificationId);

    await updateDoc(notificationRef, {
      isRead: true,
    });
  },
  onError: (error: unknown) => {
  },
});
